var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 9.14537C15.7765 9.72403 17.8334 11.0456 17.8334 12.5833C17.8334 14.6544 14.1024 16.3333 9.50002 16.3333C4.89765 16.3333 1.16669 14.6544 1.16669 12.5833C1.16669 11.0456 3.22351 9.72403 6.16669 9.14537M9.50002 12.1667V5.5M9.50002 5.5C10.8807 5.5 12 4.38071 12 3C12 1.61929 10.8807 0.5 9.50002 0.5C8.11931 0.5 7.00002 1.61929 7.00002 3C7.00002 4.38071 8.11931 5.5 9.50002 5.5Z",
    stroke: "#F9A000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDashboard);
export default __webpack_public_path__ + "static/media/location-dashboard.664d938ed7ba2efe1130c8d1e2a3efdf.svg";
export { ForwardRef as ReactComponent };